/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replacement_Text_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Replacement Text (e.g. hello world)" |
*
* @param {Replacement_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replacement_text_placeholder = /** @type {((inputs?: Replacement_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replacement_Text_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte de remplacement (ex. bonjour le monde)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzungstext (z. B. Hallo Welt)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo sostitutivo (ad esempio, ciao mondo)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заменяющий текст (например, \"hello world\")")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto de reemplazo (por ejemplo, hola mundo)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("替换文本（例如：hello world）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("置換テキスト（例：hello world）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिस्थापन पाठ (उदाहरण के लिए, हेलो वर्ल्ड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto de substituição (ex.: olá mundo)")
	return /** @type {LocalizedString} */ ("Replacement Text (e.g. hello world)")
});